import { QuestionType } from "@/models/enum/questionType";

export enum QuestionnaireTemplateCommonItemsId {
  Boolean = "Boolean",
  BooleansWithNotRelevant = "BooleansWithNotRelevant",
  Checkbox = "Checkbox",
  ContactPerson = "ContactPerson",
  Person = "Person",
  Address = "Address",
  KeyPersonnel = "KeyPersonnel",
  BeneficialOwner = "BeneficialOwner",
  Certificates = "Certificates",
  AuditResult = "AuditResult",
  ManagementPositions = "ManagementPositions",
  OwnershipPubliclyListedTypes = "OwnershipPubliclyListedTypes",
  PersonV2 = "PersonV2",
  OwnershipCompany = "OwnershipCompany",
  Company = "Company",
  PepRcaPerson = "PepRcaPerson",
  Sanctions = "Sanctions",
}

export function getCommonItemIdForQuestionType(
  questionType: QuestionType
): QuestionnaireTemplateCommonItemsId {
  switch (questionType) {
    case QuestionType.Boolean:
    case QuestionType.BooleanWithDetails:
    case QuestionType.BooleanWithDetailsOnNo:
    case QuestionType.BooleanWithMultiSelect:
      return QuestionnaireTemplateCommonItemsId.Boolean;
    case QuestionType.BooleanWithNotRelevant:
      return QuestionnaireTemplateCommonItemsId.BooleansWithNotRelevant;
    case QuestionType.Checkbox:
    case QuestionType.ListOfCheckboxes:
      return QuestionnaireTemplateCommonItemsId.Checkbox;
    case QuestionType.OwnershipPubliclyListedTypes:
      return QuestionnaireTemplateCommonItemsId.OwnershipPubliclyListedTypes;
    case QuestionType.OwnershipIndividual:
      return QuestionnaireTemplateCommonItemsId.PersonV2;
    case QuestionType.OwnershipCompany:
      return QuestionnaireTemplateCommonItemsId.OwnershipCompany;
    default:
      throw new Error("Not supported question type");
  }
}
